import React, { Component } from "react";
import "./GlobalSearch.scss";
import ItemNameIcon from "../ListView/ListViewRows/ItemNameIcon/ItemNameIcon";
import folderColor1 from "../../assets/icons/small_folder_icon/folder_color-1.svg";
import folderColor2 from "../../assets/icons/small_folder_icon/folder_color-2.svg";
import folderColor3 from "../../assets/icons/small_folder_icon/folder_color-3.svg";
import folderColor4 from "../../assets/icons/small_folder_icon/folder_color-4.svg";
import folderColor5 from "../../assets/icons/small_folder_icon/folder_color-5.svg";
import folderColor6 from "../../assets/icons/small_folder_icon/folder_color-6.svg";
import folderColorPrimary from "../../assets/icons/small_folder_icon/folder_primary.svg";
import FilePrimary from "../../assets/icons/file_pdf.svg";
import RightArrow from "../../assets/icons/arrows/chevron-right.svg";
import TagIcon from "../../assets/icons/tag.svg"
import { Link, withRouter } from "react-router-dom";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import { notify } from "../Notify/Notify";
// Animation
import UseAnimations from "react-useanimations";
import searchAnimation from "react-useanimations/lib/searchToX";
import loading from "react-useanimations/lib/infinity";

const colors = [
  null,
  folderColor1,
  folderColor2,
  folderColor3,
  folderColor4,
  folderColor5,
  folderColor6,
  folderColorPrimary,
];

class GlobalSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSearchDialog: false,
      isLoading: false,
      showInputBox: false,
      searchInputValue: "",
      searchResult: [],
    };

    this.searchRef = React.createRef();
    this.handleClickOutsideOfSearch =
      this.handleClickOutsideOfSearch.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideOfSearch);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutsideOfSearch);
  }

  handleClickOutsideOfSearch(event) {
    if (
      this.searchRef &&
      this.searchRef.current &&
      !this.searchRef.current.contains(event.target)
    ) {
      this.handleSearchInputVisibility(false);
      this.setState({ showSearchDialog: false, searchInputValue: "" });
    }
  }

  handleSearchInputVisibility = (show) => {
    this.setState({
      showInputBox: show,
      showSearchDialog: show
        ? this.state.searchResult.length > 0 &&
          this.state.searchInputValue.length > 0
          ? true
          : false
        : false,
      searchInputValue: "",
    });
  };

  loadSearchResults = () => {
    this.setState({ showSearchDialog: true, isLoading: true });

    const variables = {
      title: this.state.searchInputValue,
    };

    apolloClient
      .query({
        query: gql`
          query globalSearch($title: String!) {
            globalSearch(title: $title) {
              ... on FolderType {
                folderId: id
                id
                isRoot
                isArchive
                title
                color {
                  id
                }

                parentFolder {
                  id
                  title
                }
              }
              ... on DocumentType {
                documentId: id
                id
                title
                isArchive
                folder {
                  id
                  title
                  parentFolder {
                    id
                    title
                  }
                }
              }
              ... on TagType {
                tagId: id
                id
                name
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let searchResult = [];
        if (result.data.globalSearch.length > 0) {
          searchResult = result.data.globalSearch.map((res) => {
            return res.hasOwnProperty("tagId") 
              ? {
                  id: res.id,
                  isTag: true,
                  title: res.name,
                  isDocument: false,
                } 
              : res.hasOwnProperty("folderId")
              ? {
                  folderId: res.id,
                  isRoot: res.parentFolder === null ? true : false,
                  isArchive: res.isArchive,
                  title: res.title,
                  rootTitle: res.parentFolder ? res.parentFolder.title : "",
                  parentId: res.parentFolder ? res.parentFolder.id : "",
                  parentTitle: res.parentFolder ? res.parentFolder.title : "",
                  color: res.color,
                  parentFolder: res.parentFolder,
                  isFolder: true,
                  isTag: false,
                  isDocument: false,
                }
              : {
                  id: res.id,
                  folderId: res.folder.id,
                  isRoot: false,
                  isArchive: res.isArchive,
                  title: res.title,
                  rootTitle: res.folder.parentFolder.title,
                  parentId: res.folder.parentFolder.id,
                  parentTitle: res.folder.title,
                  color: res.color,
                  parentFolder: res.folder.parentFolder,
                  isFolder: false,
                  isTag: false,
                  isDocument: true,
                  documentId: res.id,
                };
          });
        }
        this.setState({ searchResult, isLoading: false });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  closeSearchDialog = () => {
    this.setState({ showSearchDialog: false });
  };

  getSearchResultsJSX = () => {
    const getRoute = (resultObj) => {
      if (resultObj.isTag) {
        return `/files/search/${resultObj.title}`
      } else if (resultObj.isFolder) {
        if (resultObj.isRoot) {
          return resultObj.isArchive
            ? `/archives/${resultObj.folderId}`
            : `/files/${resultObj.folderId}`;
        } else {
          return resultObj.isArchive
            ? `/archives/${resultObj.parentId}/${resultObj.folderId}`
            : `/files/${resultObj.parentId}/${resultObj.folderId}`;
        }
      } else if(resultObj.isDocument) {
        // For documents
        return resultObj.isArchive
          ? `/archives/${resultObj.parentId}/${resultObj.folderId}/${resultObj.documentId}`
          : `/files/${resultObj.parentId}/${resultObj.folderId}/${resultObj.documentId}`;
      }
    };

    return this.state.searchResult.length > 0 ? (
      this.state.searchResult.map((resultObj, index) => (
        <div className="search-slide" key={index}>
          <Link
            to={getRoute(resultObj)}
            onClick={() => {
              this.handleSearchInputVisibility(false);
              this.setState({ showSearchDialog: false });
            }}
            className="search-content"
          >
            <ItemNameIcon
              itemIcon={
                resultObj.isTag ? TagIcon : resultObj.isFolder ? colors[resultObj.color.id] : FilePrimary
              }
              item={resultObj}
              isTag={resultObj.isTag}
              isFolder={resultObj.isFolder && !resultObj.isArchive}
              rootFolderId={
                resultObj.isRoot ? resultObj.folderId : resultObj.parentId
              }
              subFolderId={resultObj.folderId}
              onClick={(id) => {}}
            />
            {
              !resultObj.isTag ? (
                <div className="location">
                  <div className="d-flex align-items-center text-col-3">
                    <div>{resultObj.isArchive ? "Archives" : "Files"}</div>
                    {resultObj.isFolder && resultObj.parentFolder ? (
                      <>
                        <img src={RightArrow} alt="arrow" width="16" height="16" />
                        <div className="1"> {resultObj.parentTitle} </div>
                      </>
                    ) : resultObj.rootTitle && resultObj.parentTitle ? (
                      <>
                        <img src={RightArrow} alt="arrow" width="16" height="16" />
                        <div className="2">
                          {resultObj.rootTitle}
                          <img
                            src={RightArrow}
                            alt="arrow"
                            width="16"
                            height="16"
                          />
                          {resultObj.parentTitle}
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              ) : null
            }
            
          </Link>
        </div>
      ))
    ) : !this.state.isLoading ? (
      <p className="text-center my-3">No matched result found!</p>
    ) : null;
  };

  render() {
    return (
      <div className="global-search-container flex-grow-1" ref={this.searchRef}>
        <div className="search d-flex justify-content-end">
          {this.state.showInputBox ? (
            <>
              <div className="flex-grow-1">
                <input
                  autoFocus
                  className="search-box"
                  type="search"
                  maxLength="300"
                  value={this.state.searchInputValue}
                  onChange={(e) =>
                    this.setState(
                      { searchInputValue: e.target.value },
                      this.loadSearchResults
                    )
                  }
                />
              </div>
              <UseAnimations
                className="inline-search-icon"
                animation={searchAnimation}
                reverse={true}
                strokeColor="Blue"
                onClick={() => this.handleSearchInputVisibility(false)}
                speed="0.9"
              />
            </>
          ) : (
            <UseAnimations
              className="global-search"
              strokeColor="#727178"
              animation={searchAnimation}
              onClick={() => this.handleSearchInputVisibility(true)}
            />
          )}
        </div>

        {this.state.showSearchDialog ? (
          <div
            className={`search-dialog-container ${
              this.state.showSearchDialog ? "show" : "hide"
            }`}
          >
            {this.state.isLoading ? (
              <div className="progress-icon">
                {/* <Spinner animation="border" role="status" /> */}
                <UseAnimations
                  animation={loading}
                  strokeColor="Blue"
                  autoplay={true}
                  loop={true}
                />
              </div>
            ) : null}

            <div className="body">{this.getSearchResultsJSX()}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRouter(GlobalSearch);
